import { useMutation } from '@apollo/client';
import { REFRESH_COGNITO_TOKENS } from 'graphql/auth/mutations/refreshCognitoTokens.gql';

export default function useRefreshCognitoTokensMutation() {
  return useMutation(REFRESH_COGNITO_TOKENS);
}
